import { render, staticRenderFns } from "./dcdcDetailSetTem.vue?vue&type=template&id=4074a85e&scoped=true"
import script from "./dcdcDetailSetTem.vue?vue&type=script&lang=js"
export * from "./dcdcDetailSetTem.vue?vue&type=script&lang=js"
import style0 from "./dcdcDetailSetTem.vue?vue&type=style&index=0&id=4074a85e&prod&lang=scss&scoped=true"
import style1 from "./dcdcDetailSetTem.vue?vue&type=style&index=1&id=4074a85e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4074a85e",
  null
  
)

export default component.exports